export const LANGUAGES = [
  { code: "fr", label: "FR" },
  { code: "nl", label: "NL" },
  { code: "en", label: "EN" },
];

export const T = {
  fr: {
    nav: { expertises: "Expertises", pourquoi: "Pourquoi nous", apropos: "À propos", realisations: "Réalisations", contact: "Contact" },
    header: { tagline: "Techniques du bâtiment", devis: "Demander un devis" },
    hero: {
      badge: "Disponible pour interventions en Belgique",
      lines: ["L'expertise technique", "de votre bâtiment,", "sans compromis."],
      subtitle: "Électricité, domotique, climatisation, ventilation, réseaux data et régulation HVAC - ACOMEP conçoit, installe et maintient les installations techniques de vos bâtiments résidentiels, tertiaires et industriels.",
      cta1: "Demander un devis",
      cta2: "Nos expertises",
      stats: [
        { value: "06", label: "Domaines d'expertise" },
        { value: "03", label: "Régions couvertes" },
        { value: "RGIE", label: "Conformité garantie" },
        { value: "48h", label: "Réponse à votre demande" },
      ],
    },
    marquee: ["Conformité RGIE", "Normes PEB", "KNX · Loxone · Zigbee", "Cat 6A / Cat 7", "Fibre Optique", "GTB / GTC", "Pompes à Chaleur", "VMC Double Flux", "Intervention Belgique"],
    expertise: {
      overline: "/ 01 - Nos domaines d'expertise",
      title: "Six métiers, une seule exigence : la précision.",
      text: "Du courant fort à la fibre optique, nous couvrons l'ensemble des installations techniques de votre bâtiment.",
      domains: [
        {
          title: "Électricité Générale & Tertiaire",
          description: "Conception, mise en œuvre et maintenance de vos installations électriques, en garantissant sécurité, performance et conformité aux normes en vigueur.",
          services: [
            { label: "Neuf & Rénovation", detail: "Installation complète de réseaux électriques pour logements, bureaux et bâtiments industriels." },
            { label: "Mise en Conformité", detail: "Audit, remise aux normes et sécurisation des tableaux et équipements électriques." },
            { label: "Éclairage & Puissance", detail: "Solutions d'éclairage LED basse consommation, colonnes montantes et gestion de la puissance." },
          ],
        },
        {
          title: "Domotique & Bâtiment Intelligent",
          description: "Centralisez et automatisez le contrôle de votre habitat ou de vos locaux professionnels pour gagner en confort, en sécurité et en sobriété énergétique.",
          services: [
            { label: "Gestion d'Éclairage & Ouvrants", detail: "Pilotage à distance des lumières, volets roulants, stores et accès via smartphone ou commandes centralisées." },
            { label: "Scénarios d'Usage & Automatisation", detail: "Scénarios personnalisés : départ, présence, nuit, gestion automatique du chauffage et de la fraîcheur." },
            { label: "Protocoles Standardisés & Évolutifs", detail: "Intégration de technologies filaires et sans fil modernes (KNX, Loxone, Zigbee…) pour une installation durable." },
          ],
        },
        {
          title: "Climatisation & Pompes à Chaleur",
          description: "Des solutions thermiques performantes et écologiques pour assurer votre confort en toute saison, été comme hiver.",
          services: [
            { label: "Pompes à Chaleur (Air/Eau & Air/Air)", detail: "Installation et remplacement de systèmes de chauffage économiques et écoresponsables." },
            { label: "Climatisation Réversible", detail: "Mono-split & multi-split sur mesure pour habitations, bureaux et surfaces commerciales." },
            { label: "Mise en Service & Entretien", detail: "Dimensionnement, recharge de fluide frigorigène, contrôle d'étanchéité et maintenance préventive." },
          ],
        },
        {
          title: "Ventilation & Traitement de l'Air",
          description: "Un air sain et une ventilation maîtrisée, essentiels pour le confort et la durabilité de vos bâtiments.",
          services: [
            { label: "VMC Simple & Double Flux", detail: "Extraction et renouvellement d'air optimisés pour limiter les pertes thermiques." },
            { label: "Ventilation Tertiaire & Industrielle", detail: "Conception de réseaux d'aération sur mesure pour locaux professionnels, bureaux et ateliers." },
            { label: "Entretien & Filtration", detail: "Maintenance régulière des centrales de traitement d'air (CTA) et remplacement des filtres." },
          ],
        },
        {
          title: "Câblage Data & Fibre Optique",
          description: "Une connectivité haut débit, fiable et évolutive pour répondre aux exigences numériques actuelles de vos infrastructures.",
          services: [
            { label: "Réseaux Informatiques", detail: "Déploiement de câblage structuré (Cat 6, Cat 6A, Cat 7) et pose de baies de brassage." },
            { label: "Fibre Optique", detail: "Soudure, raccordement, réflectométrie et qualification de liaisons optiques intérieures et extérieures." },
            { label: "Salles Serveurs & Data Centers", detail: "Organisation, repérage et optimisation de l'architecture réseau." },
          ],
        },
        {
          title: "Régulation & Gestion Technique HVAC",
          description: "Optimisez le confort thermique tout en réduisant vos consommations grâce à une régulation intelligente du chauffage, de la ventilation et de la climatisation.",
          services: [
            { label: "Automatisme & Régulation", detail: "Programmation et installation de régulateurs et centrales de gestion HVAC." },
            { label: "GTC / GTB", detail: "Pilotage centralisé et suivi en temps réel des équipements thermiques du bâtiment." },
            { label: "Optimisation Énergétique", detail: "Réglage précis des lois d'eau, des débits d'air et des consignes pour minimiser vos factures d'énergie." },
          ],
        },
      ],
    },
    whyus: {
      overline: "/ 02 - Pourquoi ACOMEP",
      title: "La rigueur d'un bureau d'études, la réactivité d'un installateur de proximité.",
      features: [
        { num: "01", title: "Rigueur d'ingénierie", text: "Dimensionnement précis, conformité RGIE et respect strict des normes en vigueur, sans approximation." },
        { num: "02", title: "Transparence & délais", text: "Devis détaillé, planning clair et engagement ferme sur les dates d'intervention et de livraison." },
        { num: "03", title: "Technologies de pointe", text: "KNX, Loxone, GTB, fibre optique : nous maîtrisons les protocoles qui font la pérennité de vos installations." },
        { num: "04", title: "Interlocuteur unique", text: "Un seul partenaire pour l'électricité, le CVC et les réseaux. Une coordination simple, un résultat cohérent." },
      ],
    },
    about: {
      overline: "/ 03 - À propos",
      title: "Un partenaire technique unique pour vos bâtiments.",
      p1: "ACOMEP réunit sous un même toit les compétences en électricité, domotique, génie climatique et réseaux de données. Cette transversalité nous permet de concevoir des installations cohérentes, optimisées et évolutives - du neuf à la rénovation, de la mise en service à la maintenance.",
      p2: "Particuliers, syndics, entreprises et maîtres d'ouvrage : nous intervenons avec la même exigence de qualité et de conformité, partout en Belgique.",
      badgeLabel: "Zone d'intervention",
      badgeValue: "Toute la Belgique",
      regions: ["Bruxelles", "Brabant Wallon", "Wallonie", "Flandre"],
    },
    realisations: {
      overline: "/ 04 - Réalisations",
      title: "Nos chantiers, en images.",
      text: "Un aperçu de nos interventions sur le terrain, partout en Belgique.",
      labels: {
        "CH-01": { title: "Tableaux & distribution électrique", place: "Bruxelles" },
        "CH-02": { title: "Pompe à chaleur air/eau", place: "Brabant Wallon" },
        "CH-03": { title: "Câblage & fibre optique", place: "Liège" },
        "CH-04": { title: "Réseaux de ventilation", place: "Namur" },
        "CH-05": { title: "Installation domotique", place: "Anvers" },
        "CH-06": { title: "Chantier industriel", place: "Charleroi" },
      },
    },
    contact: {
      overline: "/ 05 - Contact",
      title: "Parlons de votre projet.",
      text: "Décrivez votre besoin en quelques lignes : nous revenons vers vous sous 48h ouvrées avec une première analyse et, si nécessaire, une visite technique.",
      name: "Nom complet *",
      email: "E-mail *",
      phone: "Téléphone",
      service: "Service concerné",
      message: "Votre message *",
      namePh: "Jean Dupont",
      emailPh: "jean@exemple.be",
      phonePh: "+32 ...",
      messagePh: "Décrivez votre projet : type de bâtiment, travaux envisagés, délais…",
      selectPh: "Sélectionnez…",
      other: "Autre demande",
      submit: "Envoyer ma demande",
      sending: "Envoi en cours…",
      privacy: "Vos données restent confidentielles et servent uniquement au traitement de votre demande.",
      successTitle: "Demande envoyée",
      successDesc: "Merci ! L'équipe ACOMEP vous recontacte sous 48h ouvrées.",
      errorTitle: "Envoi impossible",
      errorDesc: "Une erreur est survenue. Réessayez ou contactez-nous par téléphone.",
    },
    footer: {
      tagline: "Ingénierie & techniques du bâtiment. Électricité, domotique, HVAC et réseaux data - partout en Belgique.",
      nav: "Navigation",
      expertises: "Expertises",
      coords: "Coordonnées",
      rights: "© 2026 ACOMEP - Tous droits réservés",
      made: "Conçu avec précision en Belgique",
    },
  },

  nl: {
    nav: { expertises: "Vakgebieden", pourquoi: "Waarom wij", apropos: "Over ons", realisations: "Realisaties", contact: "Contact" },
    header: { tagline: "Gebouwtechniek", devis: "Offerte aanvragen" },
    hero: {
      badge: "Beschikbaar voor interventies in België",
      lines: ["Technische expertise", "voor uw gebouw,", "zonder compromissen."],
      subtitle: "Elektriciteit, domotica, airconditioning, ventilatie, datanetwerken en HVAC-regeling - ACOMEP ontwerpt, installeert en onderhoudt de technische installaties van uw residentiële, tertiaire en industriële gebouwen.",
      cta1: "Offerte aanvragen",
      cta2: "Onze vakgebieden",
      stats: [
        { value: "06", label: "Vakdomeinen" },
        { value: "03", label: "Gewesten" },
        { value: "RGIE", label: "Conformiteit gegarandeerd" },
        { value: "48u", label: "Reactie op uw aanvraag" },
      ],
    },
    marquee: ["RGIE-conformiteit", "EPB-normen", "KNX · Loxone · Zigbee", "Cat 6A / Cat 7", "Glasvezel", "GTB / GTC", "Warmtepompen", "Ventilatie D", "Interventies in België"],
    expertise: {
      overline: "/ 01 - Onze vakgebieden",
      title: "Zes vakgebieden, één eis: precisie.",
      text: "Van krachtstroom tot glasvezel: wij dekken alle technische installaties van uw gebouw.",
      domains: [
        {
          title: "Algemene & Tertiaire Elektriciteit",
          description: "Ontwerp, uitvoering en onderhoud van uw elektrische installaties, met garantie op veiligheid, prestaties en conformiteit met de geldende normen.",
          services: [
            { label: "Nieuwbouw & Renovatie", detail: "Volledige installatie van elektrische netwerken voor woningen, kantoren en industriële gebouwen." },
            { label: "Conformiteit", detail: "Audit, aanpassing aan de normen en beveiliging van schakelborden en elektrische uitrusting." },
            { label: "Verlichting & Vermogen", detail: "Energiezuinige LED-verlichting, stijgleidingen en vermogensbeheer." },
          ],
        },
        {
          title: "Domotica & Slim Gebouw",
          description: "Centraliseer en automatiseer de bediening van uw woning of professionele ruimtes voor meer comfort, veiligheid en energiebesparing.",
          services: [
            { label: "Verlichtings- & Screenbeheer", detail: "Bediening op afstand van verlichting, rolluiken, screens en toegangen via smartphone of centrale bediening." },
            { label: "Gebruiksscenario's & Automatisering", detail: "Gepersonaliseerde scenario's: vertrek, aanwezigheid, nacht, automatisch beheer van verwarming en koeling." },
            { label: "Gestandaardiseerde & Schaalbare Protocollen", detail: "Integratie van moderne bedrade en draadloze technologieën (KNX, Loxone, Zigbee…) voor een duurzame installatie." },
          ],
        },
        {
          title: "Airconditioning & Warmtepompen",
          description: "Performante en ecologische thermische oplossingen voor uw comfort in elk seizoen, zomer én winter.",
          services: [
            { label: "Warmtepompen (Lucht/Water & Lucht/Lucht)", detail: "Installatie en vervanging van economische en milieuvriendelijke verwarmingssystemen." },
            { label: "Omkeerbare Airconditioning", detail: "Mono-split & multi-split op maat voor woningen, kantoren en commerciële ruimtes." },
            { label: "Inbedrijfstelling & Onderhoud", detail: "Dimensionering, bijvullen van koudemiddel, dichtheidscontrole en preventief onderhoud." },
          ],
        },
        {
          title: "Ventilatie & Luchtbehandeling",
          description: "Gezonde lucht en beheerste ventilatie, essentieel voor het comfort en de duurzaamheid van uw gebouwen.",
          services: [
            { label: "Ventilatiesystemen C & D", detail: "Geoptimaliseerde afvoer en verversing van lucht om warmteverliezen te beperken." },
            { label: "Tertiaire & Industriële Ventilatie", detail: "Ontwerp van ventilatienetwerken op maat voor professionele ruimtes, kantoren en ateliers." },
            { label: "Onderhoud & Filtratie", detail: "Regelmatig onderhoud van luchtbehandelingskasten (LBK) en vervanging van filters." },
          ],
        },
        {
          title: "Datakabels & Glasvezel",
          description: "Snelle, betrouwbare en schaalbare connectiviteit voor uw infrastructuur, klaar voor de digitale eisen van vandaag.",
          services: [
            { label: "Computernetwerken", detail: "Aanleg van gestructureerde bekabeling (Cat 6, Cat 6A, Cat 7) en plaatsing van patchkasten." },
            { label: "Glasvezel", detail: "Lassen, aansluiten, reflectometrie en kwalificatie van optische binnen- en buitenverbindingen." },
            { label: "Serverruimtes & Datacenters", detail: "Organisatie, identificatie en optimalisatie van de netwerkarchitectuur." },
          ],
        },
        {
          title: "Regeling & HVAC Gebouwbeheer",
          description: "Optimaliseer het thermisch comfort en verlaag uw verbruik dankzij een intelligente regeling van verwarming, ventilatie en airconditioning.",
          services: [
            { label: "Automatisering & Regeling", detail: "Programmering en installatie van regelaars en HVAC-beheercentrales." },
            { label: "GTC / GTB", detail: "Gecentraliseerde aansturing en realtime opvolging van de thermische uitrusting van het gebouw." },
            { label: "Energetische Optimalisatie", detail: "Nauwkeurige afstelling van stooklijnen, luchtdebieten en setpoints om uw energiefactuur te minimaliseren." },
          ],
        },
      ],
    },
    whyus: {
      overline: "/ 02 - Waarom ACOMEP",
      title: "De nauwkeurigheid van een studiebureau, de reactiesnelheid van een lokale installateur.",
      features: [
        { num: "01", title: "Ingenieursnauwkeurigheid", text: "Nauwkeurige dimensionering, RGIE-conformiteit en strikte naleving van de geldende normen, zonder benadering." },
        { num: "02", title: "Transparantie & deadlines", text: "Gedetailleerde offerte, duidelijke planning en een vast engagement voor interventie- en opleverdata." },
        { num: "03", title: "Geavanceerde technologieën", text: "KNX, Loxone, GTB, glasvezel: wij beheersen de protocollen die uw installaties toekomstbestendig maken." },
        { num: "04", title: "Één aanspreekpunt", text: "Eén partner voor elektriciteit, HVAC en netwerken. Eenvoudige coördinatie, een coherent resultaat." },
      ],
    },
    about: {
      overline: "/ 03 - Over ons",
      title: "Eén technische partner voor al uw gebouwen.",
      p1: "ACOMEP bundelt expertise in elektriciteit, domotica, klimaattechniek en datanetwerken onder één dak. Die transversaliteit stelt ons in staat coherente, geoptimaliseerde en schaalbare installaties te ontwerpen - van nieuwbouw tot renovatie, van inbedrijfstelling tot onderhoud.",
      p2: "Particulieren, syndici, bedrijven en bouwheren: wij werken overal in België met dezelfde eisen van kwaliteit en conformiteit.",
      badgeLabel: "Werkzone",
      badgeValue: "Heel België",
      regions: ["Brussel", "Waals-Brabant", "Wallonië", "Vlaanderen"],
    },
    realisations: {
      overline: "/ 04 - Realisaties",
      title: "Onze projecten, in beeld.",
      text: "Een overzicht van onze interventies ter plaatse, overal in België.",
      labels: {
        "CH-01": { title: "Schakelborden & elektrische distributie", place: "Brussel" },
        "CH-02": { title: "Lucht/water-warmtepomp", place: "Waals-Brabant" },
        "CH-03": { title: "Bekabeling & glasvezel", place: "Luik" },
        "CH-04": { title: "Ventilatienetwerken", place: "Namen" },
        "CH-05": { title: "Domotica-installatie", place: "Antwerpen" },
        "CH-06": { title: "Industriële werf", place: "Charleroi" },
      },
    },
    contact: {
      overline: "/ 05 - Contact",
      title: "Laten we over uw project praten.",
      text: "Beschrijf uw behoefte in enkele lijnen: wij nemen binnen 48 werkuren contact op met een eerste analyse en, indien nodig, een technisch bezoek.",
      name: "Volledige naam *",
      email: "E-mail *",
      phone: "Telefoon",
      service: "Gewenste dienst",
      message: "Uw bericht *",
      namePh: "Jan Janssens",
      emailPh: "jan@voorbeeld.be",
      phonePh: "+32 ...",
      messagePh: "Beschrijf uw project: type gebouw, geplande werken, timing…",
      selectPh: "Selecteer…",
      other: "Andere aanvraag",
      submit: "Verstuur mijn aanvraag",
      sending: "Verzenden…",
      privacy: "Uw gegevens blijven vertrouwelijk en worden enkel gebruikt voor de behandeling van uw aanvraag.",
      successTitle: "Aanvraag verzonden",
      successDesc: "Bedankt! Het ACOMEP-team contacteert u binnen 48 werkuren.",
      errorTitle: "Verzenden mislukt",
      errorDesc: "Er is een fout opgetreden. Probeer opnieuw of bel ons.",
    },
    footer: {
      tagline: "Ingenieurs- & gebouwtechniek. Elektriciteit, domotica, HVAC en datanetwerken - overal in België.",
      nav: "Navigatie",
      expertises: "Vakgebieden",
      coords: "Contactgegevens",
      rights: "© 2026 ACOMEP - Alle rechten voorbehouden",
      made: "Met precisie gemaakt in België",
    },
  },

  en: {
    nav: { expertises: "Expertise", pourquoi: "Why us", apropos: "About", realisations: "Projects", contact: "Contact" },
    header: { tagline: "Building technology", devis: "Request a quote" },
    hero: {
      badge: "Available for projects across Belgium",
      lines: ["Technical expertise", "for your building,", "without compromise."],
      subtitle: "Electricity, home automation, air conditioning, ventilation, data networks and HVAC control - ACOMEP designs, installs and maintains the technical systems of your residential, commercial and industrial buildings.",
      cta1: "Request a quote",
      cta2: "Our expertise",
      stats: [
        { value: "06", label: "Fields of expertise" },
        { value: "03", label: "Regions covered" },
        { value: "RGIE", label: "Compliance guaranteed" },
        { value: "48h", label: "Response to your request" },
      ],
    },
    marquee: ["RGIE Compliance", "EPB Standards", "KNX · Loxone · Zigbee", "Cat 6A / Cat 7", "Fiber Optics", "BMS / GTB", "Heat Pumps", "Dual-Flow Ventilation", "Belgium-wide service"],
    expertise: {
      overline: "/ 01 - Our fields of expertise",
      title: "Six trades, one standard: precision.",
      text: "From power systems to fiber optics, we cover every technical installation in your building.",
      domains: [
        {
          title: "General & Commercial Electrical",
          description: "Design, implementation and maintenance of your electrical installations, guaranteeing safety, performance and compliance with current standards.",
          services: [
            { label: "New Build & Renovation", detail: "Complete installation of electrical networks for homes, offices and industrial buildings." },
            { label: "Compliance Upgrades", detail: "Audit, upgrading to standards and securing of switchboards and electrical equipment." },
            { label: "Lighting & Power", detail: "Low-consumption LED lighting solutions, rising mains and power management." },
          ],
        },
        {
          title: "Home Automation & Smart Building",
          description: "Centralise and automate the control of your home or professional premises for greater comfort, security and energy efficiency.",
          services: [
            { label: "Lighting & Shutter Control", detail: "Remote control of lights, roller shutters, blinds and access via smartphone or centralised controls." },
            { label: "Usage Scenarios & Automation", detail: "Custom scenarios: away, presence, night, automatic heating and cooling management." },
            { label: "Standardised & Scalable Protocols", detail: "Integration of modern wired and wireless technologies (KNX, Loxone, Zigbee…) for a future-proof installation." },
          ],
        },
        {
          title: "Air Conditioning & Heat Pumps",
          description: "High-performance, eco-friendly thermal solutions for your comfort in every season, summer and winter.",
          services: [
            { label: "Heat Pumps (Air/Water & Air/Air)", detail: "Installation and replacement of economical, eco-responsible heating systems." },
            { label: "Reversible Air Conditioning", detail: "Mono-split & multi-split tailored to homes, offices and commercial spaces." },
            { label: "Commissioning & Maintenance", detail: "Sizing, refrigerant refill, leak testing and preventive maintenance." },
          ],
        },
        {
          title: "Ventilation & Air Treatment",
          description: "Healthy air and controlled ventilation, essential for the comfort and durability of your buildings.",
          services: [
            { label: "Single & Dual Flow Ventilation", detail: "Optimised extraction and air renewal to limit heat loss." },
            { label: "Commercial & Industrial Ventilation", detail: "Custom-designed ventilation networks for professional premises, offices and workshops." },
            { label: "Maintenance & Filtration", detail: "Regular maintenance of air handling units (AHU) and filter replacement." },
          ],
        },
        {
          title: "Data Cabling & Fiber Optics",
          description: "High-speed, reliable and scalable connectivity for your infrastructure, meeting today's digital demands.",
          services: [
            { label: "IT Networks", detail: "Deployment of structured cabling (Cat 6, Cat 6A, Cat 7) and patch cabinet installation." },
            { label: "Fiber Optics", detail: "Splicing, connection, reflectometry and qualification of indoor and outdoor optical links." },
            { label: "Server Rooms & Data Centers", detail: "Organisation, labelling and optimisation of network architecture." },
          ],
        },
        {
          title: "HVAC Control & Building Management",
          description: "Optimise thermal comfort while cutting consumption thanks to intelligent control of heating, ventilation and air conditioning.",
          services: [
            { label: "Automation & Control", detail: "Programming and installation of controllers and HVAC management units." },
            { label: "BMS / GTB", detail: "Centralised control and real-time monitoring of the building's thermal equipment." },
            { label: "Energy Optimisation", detail: "Precise adjustment of heating curves, airflows and setpoints to minimise your energy bills." },
          ],
        },
      ],
    },
    whyus: {
      overline: "/ 02 - Why ACOMEP",
      title: "The rigour of an engineering firm, the responsiveness of a local installer.",
      features: [
        { num: "01", title: "Engineering rigour", text: "Precise sizing, RGIE compliance and strict adherence to current standards, without approximation." },
        { num: "02", title: "Transparency & deadlines", text: "Detailed quote, clear schedule and a firm commitment to intervention and delivery dates." },
        { num: "03", title: "Cutting-edge technologies", text: "KNX, Loxone, BMS, fiber optics: we master the protocols that make your installations future-proof." },
        { num: "04", title: "Single point of contact", text: "One partner for electrical, HVAC and networks. Simple coordination, a coherent result." },
      ],
    },
    about: {
      overline: "/ 03 - About us",
      title: "A single technical partner for your buildings.",
      p1: "ACOMEP brings together expertise in electricity, home automation, climate engineering and data networks under one roof. This cross-disciplinary approach allows us to design coherent, optimised and scalable installations - from new builds to renovation, from commissioning to maintenance.",
      p2: "Homeowners, property managers, businesses and project owners: we work everywhere in Belgium with the same standards of quality and compliance.",
      badgeLabel: "Service area",
      badgeValue: "All of Belgium",
      regions: ["Brussels", "Walloon Brabant", "Wallonia", "Flanders"],
    },
    realisations: {
      overline: "/ 04 - Projects",
      title: "Our worksites, in pictures.",
      text: "A look at our on-site work, across Belgium.",
      labels: {
        "CH-01": { title: "Switchboards & electrical distribution", place: "Brussels" },
        "CH-02": { title: "Air/water heat pump", place: "Walloon Brabant" },
        "CH-03": { title: "Cabling & fiber optics", place: "Liège" },
        "CH-04": { title: "Ventilation networks", place: "Namur" },
        "CH-05": { title: "Home automation installation", place: "Antwerp" },
        "CH-06": { title: "Industrial worksite", place: "Charleroi" },
      },
    },
    contact: {
      overline: "/ 05 - Contact",
      title: "Let's talk about your project.",
      text: "Describe your needs in a few lines: we get back to you within 48 business hours with an initial analysis and, if needed, a technical visit.",
      name: "Full name *",
      email: "Email *",
      phone: "Phone",
      service: "Service required",
      message: "Your message *",
      namePh: "John Smith",
      emailPh: "john@example.com",
      phonePh: "+32 ...",
      messagePh: "Describe your project: building type, planned work, timeline…",
      selectPh: "Select…",
      other: "Other request",
      submit: "Send my request",
      sending: "Sending…",
      privacy: "Your data remains confidential and is only used to process your request.",
      successTitle: "Request sent",
      successDesc: "Thank you! The ACOMEP team will get back to you within 48 business hours.",
      errorTitle: "Sending failed",
      errorDesc: "An error occurred. Please try again or call us.",
    },
    footer: {
      tagline: "Building engineering & technology. Electrical, home automation, HVAC and data networks - across Belgium.",
      nav: "Navigation",
      expertises: "Expertise",
      coords: "Contact details",
      rights: "© 2026 ACOMEP - All rights reserved",
      made: "Precisely crafted in Belgium",
    },
  },
};
